import { AxiosWebApiClient } from '@/core/webapi/WebApiClient';
import {WebFormModel} from "capitalist-shared/src/core/model";
import { RemoteRequestState } from '@/backoffice/components/pages/taxrules/taxrules';
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";

export class CurrencyRatesData implements Record<string, any> {
    data: Record<string, any> | null = null;

    webapiClient = new AxiosWebApiClient(`${process.env.VUE_APP_API_HOST}`);

    autoUpdate = true;

    updateTimer: any = null;

    get hasData(): boolean {
      return !!this.data;
    }

    resetAutoUpdateTimer() {
      if (this.updateTimer) {
        clearTimeout(this.updateTimer);
        this.updateTimer = null;
      }
    }

    delayedUpdate(onFocus = false) {
      this.resetAutoUpdateTimer();
      this.updateTimer = setTimeout(() => {
        if (this.autoUpdate) this.updateRates();
      }, onFocus ? 500 : 10000);
    }

    updateRates() {
      httpAxiosApi.post('/webapi/webapi/rates').then((result: any) => {
        this.data = result.data.rates;
        this.delayedUpdate();
      });
    }

    get fiatList() {
      const fiats = ['USD', 'EUR', 'RUR'];
      const result: {buy: any[], sell: any[]} = { buy: [], sell: [] };
      if (!this.hasData) return result;

      for (const el of this.data.buy) {
        if ((fiats.indexOf(el.buy) >= 0)
                && (fiats.indexOf(el.sell) >= 0)) result.buy.push(el);
      }
      for (const el of this.data.sell) {
        if ((fiats.indexOf(el.buy) >= 0)
                && (fiats.indexOf(el.sell) >= 0)) result.sell.push(el);
      }
      return result;
    }

    get cryptoList() {
      const fiats = ['USD', 'EUR', 'RUR', 'UAH'];
      const result: {buy: any[], sell: any[]} = { buy: [], sell: [] };
      if (!this.hasData) return result;

      for (const el of this.data.buy) {
        if ((fiats.indexOf(el.buy) < 0)
                || (fiats.indexOf(el.sell) < 0)) result.buy.push(el);
      }
      for (const el of this.data.sell) {
        if ((fiats.indexOf(el.buy) < 0)
                || (fiats.indexOf(el.sell) < 0)) result.sell.push(el);
      }
      return result;
    }
}

export class PayoutCryptoCurrencyNoticeModel extends WebFormModel {
    loadState: RemoteRequestState = new RemoteRequestState();

    loadingRate: RemoteRequestState = new RemoteRequestState();

    rates: any = null;

    getRate(sourceCurrency: string, destCurrency: string) {
      for (const rate of this.rates.buy) {
        if (
          (rate.buy === destCurrency)
                && (rate.sell === sourceCurrency)
        ) return rate;
      }
      return null;
    }

    loadRates() {
      this.loadState.loadStart();
      return httpAxiosApi.post('/webapi/webapi/payoutrates').then((result) => {
        this.loadState.loadEnd();
        this.rates = { ...result.data.model.options.rates };
        return this.rates;
      }).catch((err) => {
        this.checkAxiosError(err);
        throw err;
      });
    }

    loadRate(src, dst, amount = 1) {
      this.loadingRate.loadStart();
      return httpAxiosApi.post('/webapi/finance/exchange', {
        call: 'estimatePayout',
        m: {
          amount,
          source: src,
          dest: dst,
        },
      }).then((result) => {
        this.loadingRate.loadEnd();
        return { ...result.data };
      }).catch((err) => {
        this.checkAxiosError(err);
        this.loadingRate.loadError();
        throw err;
      });
    }
}
